import styled from "styled-components";

export const Score = styled.div`
  display: flex;
  justify-content: center;
  font-size: 14px;
  color: whitesmoke;
`;

export const ScoreWrapper = styled.div`
  height: 88%;
  width: 65%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  background-color: rgba(85, 4, 4, 0.826);
  border: 3px solid whitesmoke;
  border-radius: 20px;
  outline: 3px solid rgb(192,20,58);
  box-shadow: 0 0 0 6px rgb(105,168,151);
`;
